import { render, staticRenderFns } from "./chateau-haut-marbuzet.vue?vue&type=template&id=d6fff716&scoped=true"
import script from "./chateau-haut-marbuzet.vue?vue&type=script&lang=js"
export * from "./chateau-haut-marbuzet.vue?vue&type=script&lang=js"
import style0 from "./chateau-haut-marbuzet.vue?vue&type=style&index=0&id=d6fff716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fff716",
  null
  
)

export default component.exports